module.exports = __webpack_public_path__ + "img/bybit.86d9fc84.png";